<script>
	import {createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();
	
	export let infobox;

	export let options = [];
	export let state;
	export let subject;
</script>

<div class="buttons">
	{#each options as o}
		{@const active = o.value === subject}
		<div
			class:active
			class="button {o.value}"
			style:color={!active ? o.color : null}
			on:click={() => {
				dispatch('update', {subj: o.value});
				infobox.update(o.value, state);
				console.log(state);

				subject = o.value;
			}}
		>
			<slot option={o} active={o.value === subject} />
		</div>
	{/each}
</div>

<style lang="scss">
	@import "../main.scss";
	$btn-black: #1f1f1f;

	.buttons {
		text-align: center;
		display: flex;
		flex-direction: row;
		text-align: center;
		overflow: hidden;
		width: fit-content;
		font-weight: $medium;
		font-family: $ff-sans;

		@media (max-width: $breakpoint-tablet-s) {
			width: auto;
			justify-content: center;
		}
	}

	.button {
		box-sizing: border-box;
		border: 1px solid;
		position: relative;
		white-space: nowrap;
		user-select: none;
		-webkit-tap-highlight-color: transparent;
		cursor: pointer;
		transition: background-color 0.3s ease, color 0.3s ease;
		padding: 5px 8px;
		color: $darkgrey;
		flex-grow: 1;
		border-radius: 5px;
		opacity: .7;
		font-size: 14px;
		line-height: 24px;
		font-weight: 500;

		&.rechtschreibung {
			color: $rechtschreibung;
			border-color: $rechtschreibung;
			width: 124px;
		}

		&.lesen {
			color: $lesen;
			border-color: $lesen;
			width: 59px;
		}

		&.mathematik {
			color: $mathematik;
			border-color: $mathematik;
			width: 62px;
		}

		&.zuhoeren {
			color: $zuhoeren;
			border-color: $zuhoeren;
			width: 73px;
		}

		


		@media (max-width: $breakpoint-tablet-s) {
			padding: 5px 10px;
			flex-grow: 0;
		}

		@media (max-width: $breakpoint-mobile-s) {
			padding: 5px 6px;
		}

		&:not(:last-child) {
			margin-right: 7px;
		}
	}

	.button.active {
		pointer-events: none;
		font-weight: $medium;
		color: $white;
		opacity: 1;
		font-weight: 600;

		&.rechtschreibung {
			background-color: $rechtschreibung;
		}

		&.mathematik {
			background-color: $mathematik;
		}

		&.zuhoeren {
			background-color: $zuhoeren;
		}

		&.lesen {
			background-color: $lesen
		}
	}
</style>
